import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getSession } from "../../Utils/SessionUtils";
import CustomSyncLoader from "../Others/CustomSyncLoader";
import ErrorCustum from "../Others/ErrorCustum";
import ImageComponent from "../Styles/ImageComponent";
import swal from "sweetalert";
import {
  addProjetComment,
  deleteProjetCommentById,
  getProjetCommentByProjetId,
  updateProjetCommentById,
} from "../../Services/Pointeuse/ProjetCommentApi";
import { isCode } from "../../Utils/InputUtils";
import { FilePond, File, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FileImageComponent from "../Styles/FileImageComponent";
import { addProjectMediaComment } from "../../Services/Pointeuse/ProjetCommentMediaApi";
import CommentMediaProject from "./CommentMediaProject";
import { t } from "i18next";
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

function CommentProjet({ projetId }) {
  const myRefFile = useRef();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setdata] = useState([]);
  const [text, setText] = useState(null);
  const [files, setFiles] = useState(null);
  const [commentId, setcommentId] = useState(null);

  const [inputList, setInputList] = useState([
    {
      code_generated: "",
      commentaire: "",
      created_at: "",
      id: "",
      img: "",
      nom: "",
      prenom: "",
      task_id: "",
      user_id: "",
    },
  ]);

  // handle input change
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleClickChange = (e, index) => {
    console.log(index);
    const list = [...inputList];
    console.log();
    if (list[index]["user_id"] == getSession("id")) {
      list[index]["update"] = true;
      console.log(list);
      setInputList(list);
    }
  };

  const handleUploadFileComment = (event) => {
    const files = event.target.files;
    // if (files) {
    for (let i = 0; i < files.length; i++) {
      addProjectMediaComment(projetId, files[i], commentId).then(() => getData());
    }
  };

  const handleSave = () => {
    addProjetComment(projetId, text).then((res) => {
      setText("");
      if (files) {
        for (let i = 0; i < files.length; i++) {
          addProjectMediaComment(projetId, files[i].file, res.data.id).then(() => getData());
        }
        setFiles(null);
      } else {
        getData();
      }
    });
  };

  const getData = () => {
    setLoading(true);
    getProjetCommentByProjetId(projetId)
      .then((res) => {
        const result = res.data;
        const newList = result.map((el) => {
          return { ...el, update: false };
        });
        setdata(res.data);
        setInputList(newList);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDelete = (id) => {
    swal({
      title: t("Ëtes-vous sûr ?"),
      text: t("Une fois supprimé, vous ne pourrez pas récupérer cet enregistrement!"),
      icon: "warning",
      // buttons: true,
      buttons: {
        cancel: t("Cancel"), // Traduisez le bouton "Cancel"
        confirm: {
          text: t("OK"), // Traduisez le bouton "OK"
          value: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteProjetCommentById(id).then(() => {
          swal("Opération effectuée avec succès!", {
            icon: "success",
          });
          getData();
        });
      }
    });
  };

  const handleUpdate = (id, comment, index) => {
    updateProjetCommentById(comment, id).then((res) => {
      console.log(res);
      const list = [...inputList];
      list[index]["update"] = false;
      console.log(list);
      setInputList(list);
    });
  };

  const handleTrigerRef = (id) => {
    setcommentId(id);
    myRefFile.current.click();
  };
  return (
    <div className="card-body">
      <div className="pt-4 pb-4 text-right"></div>
      {loading && <CustomSyncLoader></CustomSyncLoader>}
      {!loading && error && <ErrorCustum></ErrorCustum>}
      {!loading && !error && data && (
        <>
          {inputList.map((el, i) => (
            <div className="card shadow-none border">
              <div className="d-sm-flex p-5">
                <div className="d-flex mr-3">
                  <Link to="#">
                    <ImageComponent atr={"media-object brround avatar-lg"} picture={el.img}></ImageComponent>
                  </Link>
                </div>
                <div className="media-body">
                  <h5 className="mt-1 mb-1 font-weight-semibold">
                    {el.nom} {el.prenom}
                  </h5>
                  <small className="text-muted">
                    <i className="fa fa-calendar" /> {el.created_at} <i className=" ml-3 fa fa-clock-o" />
                  </small>
                  <div onClick={(e) => handleClickChange(e, i)}>
                    {el.update ? (
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          placeholder="votre commentaire"
                          rows={4}
                          name="commentaire"
                          value={el.commentaire}
                          onChange={(e) => handleInputChange(e, i)}
                        />
                      </div>
                    ) : (
                      <>
                        <br></br>
                        {isCode(el.commentaire) && (
                          <code
                            className="fs-13 mb-2 mt-1"
                            name="comment"
                            value={el.commentaire}
                            onClick={(e) => handleClickChange(e, i)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={t("Taper pour modifier")}
                          >
                            {el.commentaire}
                          </code>
                        )}
                        {!isCode(el.commentaire) && (
                          <p
                            className="fs-13 mb-2 mt-1"
                            name="comment"
                            value={el.commentaire}
                            onClick={(e) => handleClickChange(e, i)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={t("Taper pour modifier")}
                          >
                            {el.commentaire}
                          </p>
                        )}
                      </>
                    )}
                  </div>

                  <div style={{ display: "none" }} className="input-group file-browser">
                    <input type="text" className="form-control browse-file" />
                    <label className="input-group-append">
                      <span className="btn btn-primary">
                        {t("choisir fichier")}{" "}
                        <input ref={myRefFile} type="file" multiple style={{ display: "none" }} onChange={(e) => handleUploadFileComment(e)} />
                      </span>
                    </label>
                  </div>

                  <div className="row mt-2 mb-4">
                    <CommentMediaProject commentId={el.id}></CommentMediaProject>
                  </div>

                  <Link to="#" className="mr-2">
                    <span className="badge badge-danger-light" onClick={() => handleDelete(el.id)}>
                      <i className="fe fe-trash" /> {t("Supprimer")}
                    </span>
                    {el.user_id == getSession("id") && (
                      <span className="badge badge-light ml-2" onClick={() => handleTrigerRef(el.id)}>
                        <i className="fe fe-paperclip" /> {t("Ajouter")}
                      </span>
                    )}

                    {el.update && (
                      <span className="badge badge-warning-light ml-2" onClick={() => handleUpdate(el.id, el.commentaire, i)}>
                        <i className="fa fa-pencil" /> {t("Modifier")}
                      </span>
                    )}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </>
      )}

      <div className="card mb-md-0">
        <div className="card-header border-0">
          <h4 className="card-title">{t("Commentaire")}</h4>
        </div>
        <div className="card-body">
          <div className="form-group">
            <textarea className="form-control" placeholder={t("votre commentaire")} rows={6} value={text} onChange={(e) => setText(e.target.value)} />
          </div>

          <FilePond
            files={files}
            onupdatefiles={setFiles}
            allowMultiple={true}
            maxFiles={10}
            name="files"
            labelIdle='Faites glisser et déposez vos fichiers ou <span class="filepond--label-action">Parcourir</span>'
          />

          <Link to="#" className="btn btn-primary" onClick={handleSave}>
            {t("Ajouter")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CommentProjet;
